/* unplugin-vue-components disabled */import { render } from "./1.vue?vue&type=template&id=e46c99a2&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"

import "../../assets/scss/new3D_detail.scss?vue&type=style&index=0&id=e46c99a2&scoped=true&lang=scss&external"
import "./1.vue?vue&type=style&index=1&id=e46c99a2&lang=css"
import "./1.vue?vue&type=style&index=2&id=e46c99a2&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e46c99a2"]])

export default __exports__